import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageTranslations from "@i18n/types";
import { generateTranslationObject } from "@utils/design-tokens";

i18n.use(initReactI18next).init({
  compatibilityJSON: "v3",
  lng: "en",
  fallbackLng: "en",
  ns: [],
  resources: {},
});

const initializeI18n = async (
  translations: LanguageTranslations[],
  locale: string
) => {
  if (!translations || typeof translations !== "object") {
    console.error("Translations object is invalid:", translations);
    return;
  }
  // Register all the fetched translations
  Object.keys(translations).forEach((key) => {
    const translationValue = translations[key as keyof typeof translations];

    if (!translationValue) {
      console.warn(`Skipping undefined/null translation for key: ${key}`);
      return;
    }

    const value = generateTranslationObject(translationValue, translationValue);
    i18n.addResourceBundle(key, "translation", value);
  });

  // Set initial local to user's phone language, if we don't have that translation it will fall back to en
  await i18n.changeLanguage(locale);
};

export default initializeI18n;
